<template>
  <section :class="{ widget: true, className }" v-bind="dataWidgster" ref="widget">
    <h5 v-if="title && typeof title === 'string' && !customHeader" class="title">{{title}}</h5>
    <header v-if="title && customHeader" class="title" v-html="title" />
    <div v-if="!customControls && mainControls"
      class="widgetControls widget-controls">
      <a v-if="settings" href="#"><i class="la la-cog" /></a>
      <a v-if="settingsInverse" href="#" class="bg-gray-transparent inverse">
        <i class="la la-cog text-white"/>
      </a>
      <a v-if="refresh" href="#" data-widgster="load" :id="`reloadId-${randomId}`">
        <strong v-if="typeof refresh === 'string'" class="text-gray-light">{{refresh}}</strong>
        <i v-else class="la la-refresh" />
          <b-tooltip
            v-if="showTooltip"
            :placement="tooltipPlacement"
            :target="`reloadId-${randomId}`"
          >Reload
          </b-tooltip>
      </a>
      <!--<a v-if="kpiHelpTxPresented" href="#" id="panelHelp" data-widgster="load"> -->
        <!--<strong v-if="typeof kpiHelpTxPresented === 'string'" class="text-gray-light">{{kpiHelpTxPresented}}</strong>-->

        <span class="h2 text-success" v-if="scheduledGoalMet"><i  class="fa fa-thumbs-up" /></span>
        <span class="h5" v-if="kpiHelpTxPresented"><i  id="panelHelp" class="glyphicon glyphicon-question-sign" /></span>
          <b-popover v-if="showTooltip" target="panelHelp" triggers="hover" placement="right" custom-class="production-collection-popover">
            <template v-slot:title><b>Treatment Presented vs. Accepted | Procedural Breakdown</b></template>  
            <div class="help_popover">
             <p><span class="fw-semi-bold">Dollar Value of today's Presented Treatment:</span> This shows you how much in $ value was actually treatment planned (presented) TODAY. </p> 
             <p>Upon clicking on the blue button with the $ value, you'll be able to see the list of patients and procedures that have been treatment planned today.</p>
              <p>By default, when this page loads, the data shown is for ALL providers in the practice.</p>
              <p><ins>To filter and display data for a specific provider, simply select the provider from the drop-down menu.</ins></p>
              <p><span class="fw-semi-bold">Dollar value of Accepted Tx from What was Presented Today:</span> This shows you how much in $ value was actually SCHEDULED from what was treatment planned Today.</p>
              <p>Upon clicking the green button with the $ value, you'll be able to see the list of patients and procedures that haven been scheduled!</p>
              <p><span class="fw-semi-bold">Treatment Acceptance Rate:</span> % value derived from the ratio: What's accepted (scheduled) to What was treatment planned (presented) today.</p>
              <!--<p><span class="fw-semi-bold">Dollar Value of Other Accepted Treatment:</span> This shows you how much in $ value was scheduled TODAY from procedures treamtent planned in the past.</p>-->
            </div>         
          </b-popover>
      <!--</a>-->
      <!--<strong v-if="typeof kpiHelpProductionCollection === 'string'" class="text-gray-light">{{kpiHelpProductionCollection}}</strong>-->
        <span class="h5" v-if="kpiHelpProductionCollection"><i id="panelHelp2" class="glyphicon glyphicon-question-sign" /></span>
          <b-popover v-if="showTooltip" target="panelHelp2" triggers="hover" placement="right" custom-class="production-collection-popover">
            <template v-slot:title><b>Production & Collection: Breakdown by Providers and Office Totals</b></template>  
            <div class="help_popover">
              <p class="mt-2">For each provider (doctors & hygienists), you will see the following values:</p>
              <p><span class="fw-semi-bold">Production (Net):</span> Net Production completed at this point in time that includes insurance adjusted fees if patient has insurance, discounts set up if patient is on an in-house membership plan and adjustments made for anything completed so far. </p>
              <p><span class="fw-semi-bold">*** Important:</span> Claim must be generated (not necessarily sent) at the end of the Patient's appointment to reflect the net adjusted production attached to the completed appointment. </p>
              <p><span class="fw-semi-bold">Scheduled (Net):</span>  Total Net $ value on Schedule - includes insurance adjusted fees if patient has insurance, discounts set up if patient is on an in-house membership plan. Regardless of whether the appointment is completed or not, this value will reflect the net $ value of what’s on the schedule for the provider.</p>
              <p><span class="fw-semi-bold">Collection:</span> This is equal to Total Insurance Payments + Total Patient Payments received at this point in time.</p>
            </div>
          </b-popover>
        <span class="h5" v-if="kpiHelpPatientsOnSchedule"><i id="panelHelp3" class="glyphicon glyphicon-question-sign" /></span>
          <b-popover v-if="showTooltip" target="panelHelp3" triggers="hover" placement="right" custom-class="production-collection-popover">
            <template v-slot:title><b>Patients on Schedule</b></template>  
            <div class="help_popover">
              <p><span class="fw-semi-bold">Total Patients on Schedule:</span> # of patient on schedule. A patient who is being seen by multiple providers is still counted as ONE patient. </p>
              <p><span class="fw-semi-bold">Hours:</span> Hours worked by each provider determined from the providers on Schedule set up in Open Dental</p>
              <p><span class="fw-semi-bold">Scheduled Production / Hr:</span> This is the total $ value of what's on the schedule for the provider divided by the number of hours worked by the provider.</p>
            </div>
          </b-popover>
      <a v-if="fullscreen" href="#" data-widgster="fullscreen" :id="`fullscreenId-${randomId}`">
        <i class="glyphicon glyphicon-resize-full" />
        <b-tooltip
          v-if="showTooltip"
          :placement="tooltipPlacement"
          :target="`fullscreenId-${randomId}`"
        >Fullscreen
        </b-tooltip>
      </a>
      <a v-if="fullscreen" href="#" data-widgster="restore" :id="`restoreId-${randomId}`">
        <i class="glyphicon glyphicon-resize-small" />
        <b-tooltip
          v-if="showTooltip"
          :placement="tooltipPlacement"
          :target="`restoreId-${randomId}`"
        >Restore
        </b-tooltip>
      </a>
      <span v-if="collapse">
        <a href="#" data-widgster="collapse" :id="`collapseId-${randomId}`">
          <i class="la la-angle-down" />
          <b-tooltip
            v-if="showTooltip"
            :placement="tooltipPlacement"
            :target="`collapseId-${randomId}`"
          >Collapse
          </b-tooltip>
        </a>
      </span>
      <span v-if="collapse">
        <a href="#" data-widgster="expand" :id="`expandId-${randomId}`">
          <i class="la la-angle-up" />
          <b-tooltip
            v-if="showTooltip"
            :placement="tooltipPlacement"
            :target="`expandId-${randomId}`"
          >Expand
          </b-tooltip>
        </a>
      </span>
      <a v-if="close" href="#" data-widgster="close" :id="`closeId-${randomId}`">
        <strong v-if="typeof refresh === 'string'" class="text-gray-light">{{close}}</strong>
        <i v-else class="la la-remove" @click="$emit('close-widget')"/>
        <b-tooltip
          v-if="showTooltip"
          :placement="tooltipPlacement"
          :target="`closeId-${randomId}`"
        >Close
        </b-tooltip>
      </a>
    </div>
    <div v-if="customControls" v-html="customControls" class="widgetControls widget-controls" />
    <div :class="`widgetBody widget-body ${bodyClass}`">
      <slot></slot>
    </div>
  </section>
</template>

<script>
import $ from 'jquery';
import 'imports-loader?window.jQuery=jquery,this=>window!widgster'; // eslint-disable-line

export default {
  name: 'Widget',
  props: {
    customHeader: { type: Boolean, default: false },
    tooltipPlacement: { default: 'top' },
    showTooltip: { type: Boolean, default: false },
    close: { type: [Boolean, String], default: false },
    fullscreen: { type: [Boolean, String], default: false },
    collapse: { type: [Boolean, String], default: false },
    settings: { type: [Boolean, String], default: false },
    settingsInverse: { type: Boolean, default: false },
    refresh: { type: [Boolean, String], default: false },
    kpiHelpTxPresented: { type: [Boolean, String], default: false },
    scheduledGoalMet: { type: [Boolean, String], default: false },
    kpiHelpProductionCollection: {type: [Boolean, String], default: false},
    kpiHelpPatientsOnSchedule: {type: [Boolean, String], default: false},
    className: { default: '' },
    title: { default: '' },
    customControls: { default: null },
    bodyClass: { default: '' },
    options: { default: () => ({}) },
    dataWidgster: { type: Object, default: () => ({}) },
  },
  computed: {
    randomId() {
      return Math.floor(Math.random() * 100);
    },
    mainControls() {
      return !!(this.close || this.fullscreen || this.collapse
        || this.refresh || this.settings || this.settingsInverse || this.scheduledGoalMet || this.kpiHelpTxPresented || this.kpiHelpProductionCollection || this.kpiHelpPatientsOnSchedule);
    },
  },
  mounted() {
    const { options } = this;
    options.bodySelector = '.widget-body';
    $(this.$refs.widget).widgster(options);
  },
};
</script>

<style src="./Widget.scss" lang="scss" />
